import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./AppWithMenu";
// import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";
import "./css/fontawesome-pro-light.css";
import "./css/fontawesome-pro-solid.css";
import "./css/fontawesome-pro-core.css";

ReactDOM.render(
    <Router>
        <App />
    </Router>,
    document.getElementById("root")
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js